/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';

const useOutsideClick = ( ref, callback, when ) => {
    const savedCallback = useRef( callback );

    useEffect(() => {
        savedCallback.current = callback;
    });

    const handler = (e) => {
        if( ref.current && !ref.current.contains(e.target)) {
            savedCallback.current();
        }
    };

    useEffect(() => {
        if (when) {
            document.addEventListener('click', handler);
            return () => document.removeEventListener('click', handler);
        }
    }, [when]);
}

const getInitials = (nombre) => {
    if (!nombre) return '?';
    const parts = nombre.trim().split(/\s+/);
    if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    return nombre.substring(0, 2).toUpperCase();
};

export const DropdownProfesionales = ( { selectSucursal, selectServicio, profesionales, profesionalesDisabled,
    texto, handleProfesionalSelected, selectProfesional, fromGestion = false, citaActive = {}, variant = 'dropdown' } ) => {
    const { colores } = useSelector(state => state.ui);

    const [selectedIndex, setSelectedIndex] = useState((citaActive?.isProfesionalRandom) ? 0 : -1);
    const [visibility, setVisibility] = useState(false);
    const [profesionalesAll, setProfesionalesAll] = useState([]);
    const dropdownMenuRef = useRef();

    let profesionalesTemp = [];

    const showDropdown = () => {
        if( selectProfesional.visible ){
            setVisibility(true);
        }
    }

    const hideDropdown = () => {
        setVisibility(false);
    }

    const selectItem = (index) => {
        if( !selectProfesional.cambiado ){
            selectProfesional.cambiado = true;
        }
        hideDropdown();
        setSelectedIndex(index);
        handleProfesionalSelected(profesionalesAll[index]);
    }

    useOutsideClick( dropdownMenuRef, hideDropdown, visibility );

    useEffect(() => {
        // Reconstruir la lista visible siempre que haya sucursal seleccionada, aunque la lista de
        // habilitados quede vacia (p.ej. sucursal cerrada ese dia): asi no se congela la lista anterior en gris.
        if( selectSucursal.selected ){
            const idSucursal = String(selectSucursal.selected._id);
            profesionales.map( item => {
                if( item.horarioSucursales ) {
                    let prioridadSelected = 1000;
                    item.horarioSucursales.map( horario => {
                        if( horario.sucursal === idSucursal ){
                            prioridadSelected = horario.prioridad;
                        }
                        return horario; // ES Lint
                    });
                    item.prioridad = prioridadSelected;
                }
                return item;
            })
            profesionales.sort( (a,b) => {
                if( a.prioridad > b.prioridad ){
                    return 1;
                }
                if( a.prioridad < b.prioridad ){
                    return -1;
                }
                return 0;
            });
            const profesionalesSucursal = profesionales.filter(profesional => !profesional.sucursales || profesional.sucursales.includes(idSucursal));
            profesionalesDisabled.map( item => {
                if( item.horarioSucursales ) {
                    let prioridadSelected = 1000;
                    item.horarioSucursales.map( horario => {
                        if( horario.sucursal === idSucursal ){
                            prioridadSelected = horario.prioridad;
                        }
                        return horario; // ES Lint
                    });
                    item.prioridad = prioridadSelected;
                }
                return item;
            })
            profesionalesDisabled.sort( (a,b) => {
                if( a.prioridad > b.prioridad ){
                    return 1;
                }
                if( a.prioridad < b.prioridad ){
                    return -1;
                }
                return 0;
            });
            const profdisabled = profesionalesDisabled.filter(profesional => !profesional.sucursales || profesional.sucursales.includes(idSucursal));
            const profTemp = [...profesionalesSucursal, ...profdisabled];
            profesionalesTemp = [...new Set(profTemp)];
            setProfesionalesAll([...new Set(profTemp)]);
            if(profesionalesAll.length==1 && !selectProfesional.selected) selectItem(0);
        }
        if( !selectProfesional.selected ) {
            setSelectedIndex(-1);
        } else {
            if( citaActive && citaActive.isProfesionalRandom && !selectProfesional.cambiado ){
                setSelectedIndex(0);
            } else {
                profesionalesTemp.map( (profesional, idx) => {
                    if( profesional._id === selectProfesional.selected._id ){
                        setSelectedIndex(idx);
                    }
                });
            }
        }
    }, [selectProfesional, profesionales, citaActive]);

    const existsProfesional = (profesional)=> {
        return profesionales.some((prof) => prof._id === profesional._id);
    }

    if (variant === 'avatares') {
        if (!selectProfesional?.visible || profesionalesAll.length === 0) return null;
        const selectedId = selectProfesional?.selected?._id;
        const isAleatorioSelected = selectedId === '333' || selectedId === 333;
        return (
            <div className="profesional-avatares">
                <p className="profesional-avatares__label">Profesional</p>
                <div className="profesional-avatares__row">
                    {profesionalesAll.map((prof) => {
                        const isAleatorio = prof._id === '333' || prof._id === 333;
                        const isDisabled = !existsProfesional(prof);
                        const isSelected = isAleatorio ? isAleatorioSelected : (selectedId && String(prof._id) === String(selectedId));
                        return (
                            <button
                                key={prof._id}
                                type="button"
                                className={`profesional-avatares__item ${isSelected ? 'profesional-avatares__item--selected' : ''} ${isDisabled ? 'profesional-avatares__item--disabled' : ''}`}
                                style={{ borderColor: isSelected ? colores.colorPrincipal : undefined }}
                                onClick={() => !isDisabled && selectItem(profesionalesAll.indexOf(prof))}
                                disabled={isDisabled}
                                title={prof.nombre}
                            >
                                <div
                                    className="profesional-avatares__avatar"
                                    style={{
                                        backgroundColor: isSelected ? colores.colorPrincipal : undefined,
                                        backgroundImage: prof.img?.[0] ? `url(${prof.img[0]})` : undefined,
                                    }}
                                >
                                    {!prof.img?.[0] && (
                                        <span className="profesional-avatares__initials">
                                            {isAleatorio ? '?' : getInitials(prof.nombre)}
                                        </span>
                                    )}
                                    {isAleatorio && isSelected && (
                                        <span className="profesional-avatares__badge">Live</span>
                                    )}
                                </div>
                                <span className="profesional-avatares__nombre">
                                    {isAleatorio ? 'Aleatorio' : prof.nombre}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <div className="brb-select">
            <div 
                className={`brb-select-container ${ selectProfesional.visible ? 'visible' : '' } ${ visibility ? 'active' : '' }`}
                onClick={ () => visibility ? hideDropdown() : showDropdown() }
            >
                <p>{ (selectedIndex > -1) ? profesionalesAll[selectedIndex]?.nombre : texto }</p>
                {/* {
                    (fromGestion)
                    ?
                        <p>{ (selectedIndex > -1) ? profesionales[selectedIndex]?.nombre : texto }</p>
                    :
                    (aleatorio)
                    ?
                        <p>Profesional aleatorio</p>
                    :
                        <p>{ (selectedIndex > -1) ? profesionales[selectedIndex]?.nombre : texto }</p>
                } */}
                
                <div className="right-zone">
                    <p></p>
                    <span
                        className="select-arrow select-arrow-down"
                    ></span>
                </div>
            </div>
            <div ref={dropdownMenuRef} className={`brb-select-options select-profesional ${ visibility ? 'active' : '' }`}>
                {
                    //profesionales.map( (profesional, idx) => (
                    profesionalesAll.map( (profesional, idx) => (
                        existsProfesional(profesional)?
                            <div 
                                className={`brb-select-option ${(profesional.promo) ? 'gold' : ''}`}  
                                style={{ backgroundColor: colores.color6 }}
                                key={ profesional._id }
                                onClick={ () => selectItem(idx) }
                            >
                                {/* <p style={{ color: profesionales.filter(x => x._id === profesional._id) ? 'black' : 'blue' }}>{ profesional.nombre }</p> */}
                                <p>{ profesional.nombre }</p>
                                
                                <div className="right-container">
                                    <div className="price"></div>
                                    {
                                        (profesional.horarioSucursales?.length > 0)
                                        ?
                                            profesional.horarioSucursales.map( horarioSucursal => (
                                                (horarioSucursal.sucursal === selectSucursal.selected?._id)
                                                &&
                                                <div key={ uuid() } className="horario">
                                                    {
                                                        horarioSucursal.horarioTxt.map( (itemHorario, idx) => (
                                                            <p key={idx}>{ itemHorario } </p>
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        :
                                            (profesional.horarioTxt.length > 0)
                                            &&
                                            (
                                                <div className="horario">
                                                    {
                                                        profesional.horarioTxt.map( (itemHorario, idx) => (
                                                            <p key={idx}>{ itemHorario } </p>
                                                        ))
                                                    }
                                                </div>
                                            )
                                    }
                                    <div className="promo">
                                        {
                                            (profesional.promo)
                                            &&
                                            <div className="promo-container gastromond">
                                                <div>-<span>{ profesional.promo.texto}</span>{(profesional.promo.tipo === 'cifra') ? '€' : '%'}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        : 
                            <div 
                                className={`brb-select-option ${(profesional.promo) ? 'gold' : ''}`}  
                                style={{ backgroundColor: colores.color6 , color: 'lightgray'}}
                                key={ profesional._id }
                            >
                                {/* <p style={{ color: profesionales.filter(x => x._id === profesional._id) ? 'black' : 'blue' }}>{ profesional.nombre }</p> */}
                                <p>{ profesional.nombre }</p>
                            
                                <div className="right-container">
                                    <div className="price"></div>
                                    {
                                        (profesional.horarioSucursales && profesional.horarioSucursales?.length > 0)
                                        ?
                                            profesional.horarioSucursales.map( horarioSucursal => (
                                                (horarioSucursal.sucursal === selectSucursal.selected?._id)
                                                &&
                                                <div key={ uuid() } className="horario">
                                                    {
                                                        horarioSucursal.horarioTxt.map( (itemHorario, idx) => (
                                                            <p key={idx}>{ itemHorario } </p>
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        :
                                            (profesional.horarioTxt.length > 0)
                                            &&
                                            (
                                                <div className="horario">
                                                    {
                                                        profesional.horarioTxt.map( (itemHorario, idx) => (
                                                            <p key={idx}>{ itemHorario } </p>
                                                        ))
                                                    }
                                                </div>
                                            )
                                    }
                                    <div className="promo">
                                        {
                                            (profesional.promo)
                                            &&
                                            <div className="promo-container gastromond">
                                                <div>-<span>{ profesional.promo.texto}</span>{(profesional.promo.tipo === 'cifra') ? '€' : '%'}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                    ))
                }
            </div>
        </div>
    )
}
